import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { animate, state, style, transition, trigger } from '@angular/animations';



export interface PeriodicElement {
  cptcode: string;
  description: string;
}

const ELEMENT_DATA: PeriodicElement[] = [
  { cptcode: '25675', description: 'Closed treatment of dislocated wrist with manipulation' },
  { cptcode: '25676', description: 'Open treatment of dislocated wrist joint' },
  { cptcode: '25680', description: 'Closed reatment of dislocated wrist with manipulation' },
  { cptcode: '25685', description: 'Open treatment of broken and dislocted wrist bone' },
  { cptcode: '25690', description: 'Closed treatment of dislocated wrist with manipulation' },
  { cptcode: '25691', description: 'Open treatment of dislocated wrist joint' },
  { cptcode: '25692', description: 'Closed treatment of dislocated wrist with manipulation' },
  { cptcode: '25693', description: 'Open treatment of dislocated wrist joint' },
  { cptcode: '25694', description: 'Closed reatment of dislocated wrist with manipulation' },
  { cptcode: '25695', description: 'Open treatment of broken and dislocted wrist bone' },
  { cptcode: '25696', description: 'Closed treatment of dislocated wrist with manipulation' },
  { cptcode: '25697', description: 'Open treatment of dislocated wrist joint' },
  { cptcode: '25694', description: 'Closed reatment of dislocated wrist with manipulation' },
  { cptcode: '25695', description: 'Open treatment of broken and dislocted wrist bone' },
  { cptcode: '25696', description: 'Closed treatment of dislocated wrist with manipulation' },
  { cptcode: '25697', description: 'Open treatment of dislocated wrist joint' },
  { cptcode: '25697', description: 'Open treatment of dislocated wrist joint' },

];


export interface PeriodicElement1 {
  cptcodes: string;
  descriptionn: string;
  Action: string;


}

const ELEMENT_DATA1: PeriodicElement1[] = [
  { cptcodes: '25800', descriptionn: 'Fusion of entire wrist joint', Action: '' },
  { cptcodes: '15351', descriptionn: 'ADHOC TESTING', Action: '' },
  { cptcodes: '70210', descriptionn: 'X-ray of paranasal sinus,less than 3 views', Action: '' },
  { cptcodes: '70220', descriptionn: 'X-ray of paranasal sinus,complete,minimum of 3', Action: '' },
  { cptcodes: '72074', descriptionn: 'X-ray of middle spine,minimum of 4 views', Action: '' },
  { cptcodes: '72220', descriptionn: 'X-ray of pelvis,minimum of 2 views', Action: '' },
  { cptcodes: '71101', descriptionn: 'X-ray of ribs on one side of body including the chest', Action: '' },
  { cptcodes: '72202', descriptionn: 'X-ray of sacroiliac joints, 3 or more views', Action: '' },
  { cptcodes: '72200', descriptionn: 'X-ray of sacroiliac joints, less than 3 views', Action: '' },
  { cptcodes: '27326', descriptionn: 'Removal of nerve of calf muscle', Action: '' },
  { cptcodes: '72220', descriptionn: 'X-ray of pelvis,minimum of 2 views', Action: '' },
  { cptcodes: '71101', descriptionn: 'X-ray of ribs on one side of body including the chest', Action: '' },
  { cptcodes: '72202', descriptionn: 'X-ray of sacroiliac joints, 3 or more views', Action: '' },
  { cptcodes: '72200', descriptionn: 'X-ray of sacroiliac joints, less than 3 views', Action: '' },
  { cptcodes: '27326', descriptionn: 'Removal of nerve of calf muscle', Action: '' },
  { cptcodes: '72220', descriptionn: 'X-ray of pelvis,minimum of 2 views', Action: '' },
  { cptcodes: '71101', descriptionn: 'X-ray of ribs on one side of body including the chest', Action: '' },
  { cptcodes: '72202', descriptionn: 'X-ray of sacroiliac joints, 3 or more views', Action: '' },
  { cptcodes: '72200', descriptionn: 'X-ray of sacroiliac joints, less than 3 views', Action: '' },
  { cptcodes: '27326', descriptionn: 'Removal of nerve of calf muscle', Action: '' },


];


@Component({
  selector: 'app-cptmaster',
  templateUrl: './cptmaster.component.html',
  styleUrls: ['./cptmaster.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],

})

export class CptmasterComponent implements OnInit {

  displayedColumns: string[] = ['cptcode', 'description'];
  dataSource = new MatTableDataSource<PeriodicElement>(ELEMENT_DATA);

  displayedColumnss: string[] = ['cptcodes', 'descriptionn', 'Action'];
  dataSource1 = new MatTableDataSource<PeriodicElement1>(ELEMENT_DATA1);


  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;



  public show: boolean = false;



  constructor() { }

  ngOnInit() {
    this.dataSource.paginator = this.paginator;

  }


}


